export const CardTitle = ({
  children,
  className,
}: {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
}) => (
  <div className={['mb-4 text-base font-semibold lg:mb-6', className].join(' ')}>{children}</div>
);
